import { resourceGroups } from "../../constants/resources/resourceGroups";
import { ProviderType, ResourceType } from "../../../services/cloudchipr.api";

export const resourceTypesByProvider = (
  provider: ProviderType,
): ResourceType[] => {
  const providersResourceGroups = resourceGroups.get(provider);

  return (
    providersResourceGroups?.reduce((acc, resourceGroup) => {
      acc.push(...resourceGroup.resourceTypes);

      return acc;
    }, [] as ResourceType[]) ?? []
  );
};
